import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Accordion from '../../Common/Accordion/Accordion';
import styles from './StudioProductSizes.module.scss';

export interface StudioProductSizesProps {
  productSideDescriptionImage: string;
}

const StudioProductSizes: FC<StudioProductSizesProps> = ({ productSideDescriptionImage }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.productSizes}>
      {productSideDescriptionImage && (
        <Accordion title={t('txt_size_guide')} titleClassName={styles.title}>
          <img src={productSideDescriptionImage} alt="" />
        </Accordion>
      )}
    </div>
  );
};

export default StudioProductSizes;
